
export default class HashParameterService {
    constructor() {

    }
    
    getParameter(paramName) {

        let paramsString = window.location.hash.substring(1);
        if (paramsString.length <= 0) {
            return '';
        }

        let strings = paramsString.split('&');
        for (let i = 0; i < strings.length; i++) {
            if (strings[i].indexOf(paramName) > -1) {
                let param = strings[i].split('=')[1];
                return param;
            }
        }

        return '';

    }

    updateParameter(paramName, paramValue) {

        let paramsString = window.location.hash.substring(1);
        if (paramsString.length <= 0) {
            window.location.hash = paramName + '=' + paramValue;
            return;
        }

        let newHashStrings = [];
        let updated = false;
        let strings = paramsString.split('&');
        for (let i = 0; i < strings.length; i++) {
            let pName = strings[i].split('=')[0];
            if (pName.localeCompare(paramName) === 0) {
                //update parameter already in hash
                if (paramValue !== '') {
                    //only update parameter if it has value
                    newHashStrings.push(paramName + '=' + paramValue);
                }
                updated = true;
            } else {
                //keep parameter already in hash
                newHashStrings.push(strings[i]);
            }
        }

        if (!updated && paramValue !== '') {
            //add parameter not in hash
            newHashStrings.push(paramName + '=' + paramValue);
        }

        window.location.hash = newHashStrings.join('&');

    }

    removeParameter(paramName) {
        let paramsString = window.location.hash.substring(1);
        if (paramsString.length <= 0) {
            return;
        }

        let newHashStrings = [];
        let strings = paramsString.split('&');
        for (let i = 0; i < strings.length; i++) {
            let pName = strings[i].split('=')[0];
            if (pName.localeCompare(paramName) !== 0) {
                // only keep parameters that are not the one we want to remove
                newHashStrings.push(strings[i]);
            }
        }

        window.location.hash = newHashStrings.join('&');
    }


}